import { createI18n } from 'vue-i18n';

import { getBrowserLanguage } from '@/static/languages';
import transformedMessages from '@/static/messageBylanguages.js';

const savedLocale = localStorage.getItem('locale') || getBrowserLanguage();

export const i18n = createI18n({
  legacy: false, // 레거시 모드 사용 여부 (true: Vue 2.x와 호환, false: Vue 3.x 등 composition API 호환)
  locale: savedLocale, // 기본 언어 설정
  fallbackLocale: savedLocale, // 기본 언어로 돌아갈 때 사용할 언어
  messages: transformedMessages,
  globalInjection: true,
});
